import { useRef } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import useDisplay from "../../../hooks/useDisplay";
import { fileUrl } from "../../../api/api";
import { openSafeLink } from "../../../util/openSafeLink";

function SBannerSwiper({ bannerList = [] }) {
  const swiperRef = useRef();

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  return (
    <>
      <div
        style={{
          width: "100%",
        }}
      >
        <Swiper
          modules={[Autoplay, Navigation]}
          onSwiper={(it) => {
            swiperRef.current = it;
          }}
          slidesPerView={1}
          centeredSlides={true}
          spaceBetween={0}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {bannerList?.length > 0
            ? bannerList?.map((item, index) => {
                return (
                  <SwiperSlide key={item.id ?? index}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        width: "100%",
                        height: "auto",
                        position: "relative",
                        objectFit: "contain",
                      }}
                    >
                      <img
                        onClick={() => {
                          openSafeLink(item.link, item.newOpen);
                        }}
                        style={{
                          cursor: item.link ? "pointer" : "default",
                          width: "100%",
                          height: "100%",
                        }}
                        src={
                          isSmall
                            ? `${fileUrl}/${item.imageServerFileNameMo}`
                            : `${fileUrl}/${item.imageServerFileNamePc}`
                        }
                        alt={item.title || "금융 스터디 배너"}
                      />
                    </div>
                  </SwiperSlide>
                );
              })
            : null}
        </Swiper>
      </div>
    </>
  );
}

export default SBannerSwiper;
